import React from 'react';
import { arrayOf, string } from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { grey_1100 } from '@fiverr-private/sass/helpers/index';
import { Icon, Tooltip } from '@fiverr-private/fit';
import { r_globe } from '@fiverr-private/icons';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { EXPERT_LANGUAGES_LEVEL } from '@fiverr-private/experts';

import './style.scss';

const Languages = ({ className, languages = [] }) => {
    let validLanguages = languages.filter((item) => [EXPERT_LANGUAGES_LEVEL.Fluent, EXPERT_LANGUAGES_LEVEL.Native].includes(item.level));

    if (isEmpty(validLanguages)) {
        return null;
    }

    let tooltipLanguages = [];
    if (validLanguages.length > 2){
        tooltipLanguages = validLanguages.slice(2);
        validLanguages = validLanguages.slice(0, 2);
    }

    const toStringLanguages = (languages) => languages.map((code) => translate(`languages.codes.${code.name}`)).join(', ');

    return (
        <div className={classnames(className)}>
            <Icon color={grey_1100}>{r_globe}</Icon>
            <span className="languages m-l-8 co-text-darker text-semi-bold">
                <I18n k="gig_page_perseus.expert_card.languages.speaks"/>&nbsp;
                {toStringLanguages(validLanguages)}
            </span>
            {!isEmpty(tooltipLanguages) &&
                <Tooltip className="m-l-8 co-text-darker expert-languages-tooltip" content={toStringLanguages(tooltipLanguages)}>
                    <span className="plus-more-label">
                        <I18n k={'gig_page_perseus.overview.language.more'}
                            params={{ count: tooltipLanguages.length }}/>
                    </span>
                </Tooltip>
            }
        </div>
    );
};

Languages.propTypes = {
    className: string,
    languages: arrayOf(string)
};

export default Languages;
